import "./../styles/main.scss";
// JQuery Ecosystem
import $ from "jquery";
require("./helpers/jQueryPlugins");
import { initSizeGuide } from "./helpers/SizeGuide";
$.expr[':'].contains = function (a, i, m) {
    return $(a).text().toUpperCase()
        .indexOf(m[3].toUpperCase()) >= 0;
};
function throttle(func, delay) {
    let timeoutId;
    let lastExecTime = 0;
    return function (...args) {
        const currentTime = Date.now();
        if (currentTime - lastExecTime > delay) {
            func.apply(this, args);
            lastExecTime = currentTime;
        }
        else {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(this, args);
                lastExecTime = Date.now();
            }, delay - (currentTime - lastExecTime));
        }
    };
}
function tabHeight() {
    let height = 0;
    let l = $('.woocommerce-Tabs-panel').length;
    $('.woocommerce-Tabs-panel').each((k, item) => {
        let oHeight = $(item).height();
        if (oHeight > height)
            height = oHeight;
        if (k + 1 == l)
            $('.woocommerce-Tabs-panel').css({ minHeight: height });
    });
}
$(document).ready(function () {
    $('.has-submenu').on("mouseenter", (e) => {
        e.preventDefault();
        $("#submenu").fadeIn();
        $('#main-header').addClass('cannothidden');
    });
    $('#main-header .menu-item').on("mouseenter", (e) => {
        if ($('#main-header').hasClass('cannothidden') && $(e.currentTarget).hasClass("has-submenu")) {
            if ($(e.currentTarget).hasClass("jewellery")) {
                if (!$("nav[data-menu='jewellery']").is(":visible")) {
                    $("#submenu nav").hide();
                    $("nav[data-menu='jewellery']").show(300);
                }
            }
            else if ($(e.currentTarget).hasClass("about")) {
                if (!$("nav[data-menu='about']").is(":visible")) {
                    $("#submenu nav").hide(300);
                    $("nav[data-menu='about']").show(300);
                }
            }
        }
        else {
            $("#submenu").fadeOut(400);
            $("#main-header").removeClass("cannothidden");
        }
    });
    $('.close-btn').on("click", "a", (e) => {
        e.preventDefault();
        $("#submenu").fadeOut(400);
        $("#main-header").removeClass("cannothidden");
    });
    var lastScrollTop = 0;
    let scrollFn = function () {
        var st = $(window).scrollTop();
        if (st > 30) {
            $('#main-header').addClass('scrolled');
            if (st > lastScrollTop) {
                $('#main-header').addClass('hidden');
            }
            else {
                $('#main-header').removeClass('hidden');
            }
        }
        else {
            $('#main-header').removeClass('scrolled');
        }
        lastScrollTop = st;
    };
    $(window).scroll(scrollFn);
    scrollFn.call(null);
    let productsWrapper = $("body").find(".products-wrapper");
    $('.single-product').on("click", "button[type='reset']", (e) => { window.location = $(".form-filter").attr("action"); });
    $('.single-product .form-filter').on("change", "input", () => {
        $('.single-product .form-filter').submit();
    });
    $('#submenu .form-filter').on("change", "input", () => {
        $('#submenu .form-filter').submit();
    });
    $("body").on("click", ".gototop", (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    $('.wc-block-cart-item__remove-link').each((k, v) => {
        $(v).text("X");
    });
    $("#mobile-nav").on("click", "a[href='#menu']", (e) => {
        e.preventDefault();
        $("#mobile-nav").toggleClass("open");
        if ($("#mobile-nav").hasClass("open"))
            $("#main-header").addClass("cannothidden");
        else
            $("#main-header").removeClass("cannothidden");
    });
    $("body").on("click", "a[href='#open-filter'], .form-filter button", (e) => {
        e.preventDefault();
        $(".sidebar").toggleClass("open");
        if ($(".sidebar").hasClass("open")) {
            $("#main-header").addClass("cannothidden");
            $("body").addClass("sidebaropened");
        }
        else {
            $("#main-header").removeClass("cannothidden");
            $("body").removeClass("sidebaropened");
        }
    });
    // Fonction pour construire l'URL avec les paramètres du formulaire
    function buildUrlWithFormData(form) {
        const baseUrl = form.attr('action') || window.location.pathname;
        const formData = form.serializeArray();
        const params = new URLSearchParams();
        formData.forEach(function (field) {
            if (field.value && field.value !== '') {
                params.append(field.name, field.value);
            }
        });
        const queryString = params.toString();
        return queryString ? `${baseUrl}?${queryString}` : baseUrl;
    }
    // Numéro de la dernière requête de filtrage : une réponse plus ancienne arrivée en retard est ignorée
    // (sinon elle écraserait la liste produits et les options de filtres de la sélection courante)
    let filterRequestSeq = 0;
    // Filtres contextuels : remplace les options de la sidebar (.filter-options) par celles de la réponse
    // (options sans produit masquées côté serveur), en conservant l'état ouvert/fermé des sous-listes,
    // les cases cochées et le scroll de l'overlay mobile. Les handlers sont délégués (form / body) : rien à rebrancher.
    function refreshFilterOptions($data) {
        const current = formItem.node.find(".filter-options");
        const fresh = $data.find(".sidebar .filter-options").first();
        if (!current.length || !fresh.length)
            return;
        const openState = {};
        current.find("a[href='#more'][data-toggle]").each((k, a) => {
            openState[$(a).attr("data-toggle")] = $(a).hasClass("active");
        });
        const checkedState = {};
        current.find("input[id]").each((k, input) => {
            checkedState[input.id] = input.checked;
        });
        const scroller = formItem.node.find(".filters-wrapper");
        const scrollTop = scroller.scrollTop();
        current.html(fresh.html());
        current.find("a[href='#more'][data-toggle]").each((k, a) => {
            const key = $(a).attr("data-toggle") || "";
            if (key in openState) {
                $(a).toggleClass("active", openState[key]);
                $(a).parent().next(".sub").css("display", openState[key] ? "block" : "none");
            }
        });
        current.find("input[id]").each((k, input) => {
            if (input.id in checkedState)
                input.checked = checkedState[input.id];
        });
        scroller.scrollTop(scrollTop);
    }
    // Wrapper pour votre code AJAX existant avec pushState
    function ajaxWithPushState(form, formItem, updateHistory = true) {
        const originalSuccess = formItem.success;
        const newUrl = buildUrlWithFormData(form);
        const requestId = ++filterRequestSeq;
        // Modifier temporairement la fonction success
        formItem.success = function (response) {
            if (requestId !== filterRequestSeq)
                return;
            // Exécuter votre fonction success originale
            if (originalSuccess) {
                originalSuccess(response);
            }
            // Ajouter le pushState après le succès
            if (updateHistory && newUrl !== window.location.href) {
                const state = {
                    formData: form.serialize(),
                    url: newUrl,
                    timestamp: Date.now()
                };
                history.pushState(state, '', newUrl);
            }
        };
        // Votre code AJAX original - INCHANGÉ
        $.ajax({
            type: form.attr('method'),
            url: form.attr('action'),
            data: form.serialize(),
            success: formItem.success,
            beforeSend: formItem.before
        });
        // Restaurer la fonction success originale
        formItem.success = originalSuccess;
    }
    let formItem = {
        node: $(".products-page-archive .sidebar .form-filter"),
        before: function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            productsWrapper.fadeOut(250, () => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                $('.loading').show();
            });
        },
        success: function (data) {
            const $data = $(data);
            let html = ($data.find(".products-wrapper").html());
            productsWrapper.html(html);
            refreshFilterOptions($data);
            $('.loading').fadeOut(250, () => {
                productsWrapper.fadeIn(250, () => {
                    $('.loading').hide();
                });
            });
            // productsWrapper.fadeOut(250,()=> {
            //     productsWrapper.fadeIn(200);
            // });
        },
        action: function () {
            var form = formItem.node;
            // $.ajax({
            //     type: form.attr('method'),
            //     url: form.attr('action'),
            //     data: form.serialize(),
            //     success: formItem.success,
            //     beforeSend: formItem.before
            // });
            ajaxWithPushState(form, formItem);
        }
    };
    $('#mobile-nav .form-filter').on("change", "input", () => {
        // if ($(window).width())
        $('#mobile-nav .form-filter').submit();
    });
    let clicked = false;
    $('body').on("click", ".page-numbers", (e) => {
        e.preventDefault();
        let paged = $(e.currentTarget).data("paged");
        if ($(e.currentTarget).hasClass("prev") || $(e.currentTarget).hasClass("next")) {
            paged = $(e.currentTarget).children("span").data("paged");
        }
        if (paged !== void 0) {
            $("#paged-form").val($(e.currentTarget).data("paged"));
            formItem.action();
        }
        // $.ajax({
        //     url: $(e.currentTarget).attr("href"),
        //     beforeSend: formItem.before,
        //     success: (data) => {
        //         formItem.success(data);
        //         window.scrollTo({top: 0, behavior: 'smooth'});
        //     }
        // });
    });
    $("body").on("click", ".form-filter a[href='#more']", (e) => {
        e.preventDefault();
        $(e.currentTarget).toggleClass("active");
        $(e.currentTarget).parent().next('.sub').slideToggle(200);
    });
    // Réinitialisation des filtres : partagée par le bouton reset de .form-filter et le lien mobile "Clear filters" (.selectors)
    function clearFilters(e) {
        e.preventDefault();
        // Le reset natif est bloqué par le preventDefault du handler ".form-filter button" (et restaurerait
        // l'état coché au chargement) : on décoche à la main puis on met l'URL à jour
        $(".form-filter").find("input[type='checkbox'], input[type='radio']").prop("checked", false);
        $("#paged-form").val(1);
        const url = $(".form-filter").attr("action");
        const requestId = ++filterRequestSeq;
        $.ajax({
            url: url,
            success: (data) => {
                if (requestId !== filterRequestSeq)
                    return;
                formItem.success(data);
                if (url !== window.location.href) {
                    history.pushState({ formData: formItem.node.serialize(), url: url, timestamp: Date.now() }, '', url);
                }
            },
            beforeSend: formItem.before
        });
    }
    $('body').on("click", ".form-filter button[type='reset']", clearFilters);
    // Lien hors du formulaire : n'ouvre pas l'overlay (le toggle ne cible que "a[href='#open-filter'], .form-filter button")
    $('body').on("click", ".selectors a[href='#clear-filters']", clearFilters);
    $("body").on("click", ".filter-button:not(.search-item)", (e) => {
        e.preventDefault();
        let id = $(e.currentTarget).attr("href");
        $(id).attr("checked", false);
        $(id).prop("checked", false);
        $(id).css({ fontWeight: "bold" });
        formItem.action();
        $(e.currentTarget).fadeOut(150, () => { $(e.currentTarget).remove(); });
    });
    $("body").on("click", ".filter-button.search-item", (e) => {
        e.preventDefault();
        $('.search-form-item').val("");
        formItem.action();
        $(e.currentTarget).fadeOut(150, () => { $(e.currentTarget).remove(); });
    });
    $('a[href="#search"]').on("click", (e) => {
        e.preventDefault();
        $(".search-box form").toggleClass("active");
        if ($(".search-box form").hasClass("active")) {
            $(".search-box form").children("input[name='s']").focus();
        }
    });
    // $('#main-header').on("mouseout", (e)=>{
    //     $(".search-box form").removeClass("active");
    // });
    if ($(".single-product").length) {
        $(window).resize(() => {
            tabHeight();
        });
        tabHeight();
    }
    if ($('.event-slider').length) {
        $('.event-slider').each((k, item) => {
            // $(item).find(".splide__slide").length
        });
    }
    formItem.node.on("change", "input", function () {
        $("#paged-form").val(1);
        formItem.action();
    });
    formItem.node.on("submit", (e) => {
        e.preventDefault();
        formItem.action();
    });
    // Bagues : texte "Need help with the size" inséré après l'add-on Size + guide des tailles en pop-up
    initSizeGuide();
    const nativeSelects = document.querySelectorAll('.wc-pao-addon-select');
    nativeSelects.forEach(nativeSelect => {
        // Créer les éléments du custom select
        const wrapper = document.createElement('div');
        wrapper.className = 'custom-select-wrapper';
        const customSelect = document.createElement('div');
        customSelect.className = 'custom-select';
        const trigger = document.createElement('div');
        trigger.className = 'custom-select__trigger';
        const span = document.createElement('span');
        span.textContent = nativeSelect.options[nativeSelect.selectedIndex].text;
        const arrow = document.createElement('div');
        arrow.className = 'arrow';
        const optionsContainer = document.createElement('div');
        optionsContainer.className = 'custom-options';
        // Ajouter les options
        Array.from(nativeSelect.options).forEach(option => {
            if (option.value !== '') {
                const customOption = document.createElement('div');
                customOption.className = 'custom-option';
                customOption.textContent = option.text;
                customOption.dataset.value = option.value;
                if (option.selected) {
                    customOption.classList.add('selected');
                }
                customOption.addEventListener('click', function () {
                    nativeSelect.value = option.value;
                    if (option.value.includes("resize-")) {
                        $('.wc-pao-addon-id-1674728564').css({ height: "auto", opacity: 1 }).show();
                        $('.wc-pao-addon-id-1674728564').find("input").attr("required", true);
                    }
                    else {
                        $('.wc-pao-addon-id-1674728564').css({ height: "0", opacity: 0 }).hide();
                        $('.wc-pao-addon-id-1674728564').find("input").attr("required", false);
                    }
                    span.textContent = option.text;
                    // Mettre à jour la sélection visuelle
                    optionsContainer.querySelectorAll('.custom-option').forEach(opt => {
                        opt.classList.remove('selected');
                    });
                    this.classList.add('selected');
                    // Fermer le dropdown
                    customSelect.classList.remove('open');
                    // Déclencher l'événement change
                    nativeSelect.dispatchEvent(new Event('change'));
                    /* Add-on for conditionnal product add-ons */
                    if (window.WC_PAO && window.WC_PAO.initialized_forms) {
                        window.WC_PAO.initialized_forms.forEach((function (form) {
                            form.$el.trigger('updated_addons');
                        }));
                    }
                });
                optionsContainer.appendChild(customOption);
            }
        });
        // Assembler les éléments
        trigger.appendChild(span);
        trigger.appendChild(arrow);
        customSelect.appendChild(trigger);
        customSelect.appendChild(optionsContainer);
        wrapper.appendChild(customSelect);
        // Insérer le wrapper avant le select natif
        nativeSelect.parentNode.insertBefore(wrapper, nativeSelect);
        wrapper.appendChild(nativeSelect);
        // Gérer le clic sur le trigger
        trigger.addEventListener('click', function (e) {
            e.stopPropagation();
            customSelect.classList.toggle('open');
        });
        // Fermer quand on clique ailleurs
        document.addEventListener('click', function () {
            customSelect.classList.remove('open');
        });
        // Mettre à jour le custom select quand le select natif change
        nativeSelect.addEventListener('change', function () {
            span.textContent = this.options[this.selectedIndex].text;
        });
    });
    $(".wcc-crnt-currency").on("click", (e) => {
        if ($(e.currentTarget).hasClass("wcc-list-opened"))
            $(e.currentTarget).parent().addClass("active");
        else
            $(e.currentTarget).parent().removeClass("active");
    });
    // Gestionnaire pour le bouton "back" du navigateur
    window.addEventListener('popstate', function (event) {
        if (event.state && event.state.formData) {
            // Trouver le formulaire (ajustez le sélecteur selon votre contexte)
            const form = $('form'); // ou votre sélecteur spécifique
            if (form.length) {
                // Remplir le formulaire avec les données de l'état
                const params = new URLSearchParams(event.state.formData);
                form.find('input, select, textarea').each(function () {
                    const field = $(this);
                    const name = field.attr('name');
                    if (name && params.has(name)) {
                        const value = params.get(name);
                        if (field.is(':checkbox') || field.is(':radio')) {
                            field.prop('checked', field.val() === value);
                        }
                        else {
                            field.val(value);
                        }
                    }
                });
                // Relancer votre requête AJAX originale sans mettre à jour l'historique
                ajaxWithPushState(form, formItem, false);
            }
        }
    });
    // ajaxWithPushState(formItem.node, formItem);
    let isCurrentlySyncing = false;
    $('body').on("click", ".add-to-cart.reseller button", (e) => {
        e.preventDefault();
        let parent = $(e.currentTarget).parents(".add-to-cart.reseller");
        if (!isCurrentlySyncing) {
            $.ajax({
                type: parent.attr('method'),
                url: parent.attr('action'),
                data: parent.serialize(),
                success: (data) => {
                    isCurrentlySyncing = false;
                    parent.find(".loader-wrapper").hide();
                    parent.find(".ok").fadeIn(400);
                    setTimeout(() => {
                        parent.find(".ok").hide();
                        parent.find(".action").show();
                    }, 3000);
                },
                beforeSend: () => {
                    if (!isCurrentlySyncing)
                        isCurrentlySyncing = true;
                    parent.find(".action").hide();
                    parent.find(".loader-wrapper").show();
                }
            });
        }
    });
});
